import { initializeApp, getApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

import { getMessaging } from "firebase/messaging";


var firebaseConfig = {};
if(localStorage.getItem("erp_type")){
	if(localStorage.getItem("erp_type") == 'kips'){
		console.log('fire-kips:');
		firebaseConfig = {
		  apiKey: "AIzaSyA_UKxyP7SSBRGI5hswmZJ-bCKpCmjTFow",
		  authDomain: "kidzonia-international-pre-sch.firebaseapp.com",
		  projectId: "kidzonia-international-pre-sch",
		  storageBucket: "kidzonia-international-pre-sch.appspot.com",
		  messagingSenderId: "10364828670",
		  appId: "1:10364828670:web:fba50e2e2f372b966fdeaf",
		  measurementId: "G-V2G8TVZSWY"
		};
	}else{
		console.log('fire-kcis-1:');
		firebaseConfig = {
		  apiKey: "AIzaSyD_gaHDNb3_f16aAAKE5DJUuajGFsgCDMo",
		  authDomain: "kcis-parents.firebaseapp.com",
		  projectId: "kcis-parents",
		  storageBucket: "kcis-parents.appspot.com",
		  messagingSenderId: "25062579875",
		  appId: "1:25062579875:web:669a989640b215bd0c6916",
		  measurementId: "G-PGJQR3EM23"
		};
	}
}else{
	console.log('fire-kcis-2:');
	firebaseConfig = {
	  apiKey: "AIzaSyD_gaHDNb3_f16aAAKE5DJUuajGFsgCDMo",
	  authDomain: "kcis-parents.firebaseapp.com",
	  projectId: "kcis-parents",
	  storageBucket: "kcis-parents.appspot.com",
	  messagingSenderId: "25062579875",
	  appId: "1:25062579875:web:669a989640b215bd0c6916",
	  measurementId: "G-PGJQR3EM23"
	};
}



const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = initializeFirestore(app, {experimentalForceLongPolling: true});

const messaging = getMessaging(app);

 
export { db, auth, messaging }; 

